export default __webpack_public_path__ + "static/media/PMPK.14c1562c.png";